import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadingStrategy, Route } from '@angular/router';
import { of, Observable, timer } from 'rxjs';
import { GameComponent } from './game/game.component';
import { AuthGuard, NoAuthGuard } from './core/guards/auth.guard';
import { 
  LoginComponent, 
  RegisterComponent, 
  ForgotPasswordComponent,
  ResetPasswordComponent,
  VerifyEmailComponent,
  HomeComponent
} from './@theme';
import { flatMap } from 'rxjs/operators';
export class AppPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: Function): Observable<any> {
    const loadRoute = (delay) => delay
      ? timer(200).pipe(flatMap(_ => load()))
      : load();
    return route.data && route.data.preload
      ? loadRoute(route.data.delay)
      : of(null);
  }
}

const routes: Routes = [
  {
    path: '',
    canActivate : [AuthGuard],
    component: HomeComponent,
    data: {
      preload: true, delay: false,
      meta: {
        title: 'Home',
        description: 'Bouncy Coin'
      }
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate : [NoAuthGuard],
    data: {
      preload: true, delay: false,
      meta: {
        title: 'Login',
        description: 'Bouncy Coin'
      }
    }
  },
  {
    path: 'register',
    canActivate : [NoAuthGuard],
    component: RegisterComponent,
    data: {
      preload: false, delay: false,
      meta: {
        title: 'Sign Up',
        description: 'Bouncy Coin'
      }
    }
  },
  {
    path: 'forgot-password',
    canActivate : [NoAuthGuard],
    component: ForgotPasswordComponent,
    data: {
      preload: false, delay: false,
      meta: {
        title: 'forgot password',
        description: 'Bouncy Coin'
      }
    }
  },
  {
    path: 'reset-password',
    canActivate : [NoAuthGuard],
    component: ResetPasswordComponent,
    data: {
      preload: true, delay: true,
      meta: {
        title: 'reset password',
        description: 'Bouncy Coin'
      }
    }
  },
  {
    path: 'validate',
    canActivate : [NoAuthGuard],
    component: VerifyEmailComponent,
    data: {
      preload: true, delay: true,
      meta: {
        title: 'verify E-mail',
        description: 'Bouncy Coin'
      }
    }
  },
  {
    path: 'roulette-game',
    canActivate : [AuthGuard],
    component: GameComponent,
    data: {
      preload: true, delay: true,
      meta: {
        title: 'Roulette Game',
        description: 'Bouncy Coin'
      }
    }
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  providers: [AppPreloadingStrategy],
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: AppPreloadingStrategy,
      onSameUrlNavigation: 'reload'
    })
  ],
  exports: [RouterModule]
})

export class AppRoutingModule { }
